module.exports = __webpack_public_path__ + "static/media/powerup.aac40b6c.PNG";